import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";

import selectedIcon from "assets/images/selectdeadline.svg";

import "./TypeButton.scss";

const PERSON_TYPES = {
  private: {
    title: "Частное лицо",
    benefits: ["Оплата онлайн через Робокассу", "Зачисление мгновенно"],
    ariaLabel: "Выбрать частное лицо"
  },
  business: {
    title: "Юр. лицо / ИП",
    benefits: ["Счет в ЭДО / PDF для бухгалтерии", "Сумма от 5 000 ₽ + комиссия 6%"],
    ariaLabel: "Выбрать юридическое лицо"
  }
};

export const TypeButton = (({ type, isSelected, onClick }) => {
  const config = PERSON_TYPES[type];

  return (
    <div className={`type-button ${isSelected ? "active" : ""}`} onClick={onClick}>
      <div className="type-button__description">
        <p className="type-button__description-title">{config.title}</p>
        <ul className={isSelected ? "selected" : ""}>{config.benefits.map((benefit, index) => <li key={index}>{benefit}</li>)}</ul>
      </div>
      <ButtonWithIcon
        className={`type-button__button ${isSelected ? "selected" : ""}`}
        title={isSelected ? "Выбрано" : "Выбрать"}
        icon={isSelected ? selectedIcon : ""}
        ariaLabel={config.ariaLabel}
      />
    </div>
  );
});
